export default __webpack_public_path__ + "static/media/logoM.11601fa8.webp";